{
  "errors": {
    "yourRoleDoesNotAllowThisAction": "お使いのロールでは{action}を実行できません",
    "yourRoleDoesNotAllowYouToPerformThisAction": "お使いのロールではこの操作を実行できません",
    "mustHaveAtLeast8Characters": "8 文字以上である必要があります",
    "mustContainUpperCaseAndLowerCase": "大文字と小文字を含める必要があります",
    "mustContainAtLeastOneLetter": "英字を 1 文字以上含める必要があります",
    "mustContainAtLeastOneSpecialCharacter": "記号を 1 文字以上含める必要があります",
    "mustContainAtLeastOneNumber": "数字を 1 文字以上含める必要があります"
  },
  "descriptions": {
    "allPermissionsAndFullControlOverAllAccounts": "すべてのアカウントに対するすべての権限と完全な管理権限。",
    "godRoleWithLessControl": "GOD ロールより管理権限が限定されたロール。",
    "allPermissionsAndFullControlOverTheOrganizationAccount": "組織アカウントに対するすべての権限と完全な管理権限。",
    "createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners": "予約、倉庫、荷物の種類、ドック、ユーザー（オーナーを除く）の作成・編集・削除。",
    "createEditCancelAppointments": "予約の作成・編集・キャンセル。",
    "editAppointmentStatusTagsAndSubscribers": "予約のステータス、タグ、通知受信者の編集。",
    "viewOnlyNoCreateOrEditActionsAllowed": "閲覧のみ。作成・編集の操作はできません。",
    "carrierAdministrator": "運送会社の管理者。",
    "carrierUser": "運送会社のユーザー",
    "baseUserAccount": "基本ユーザーアカウント。",
    "warehouseDriverHasLimitedAccessToTheApplication": "倉庫のドライバー。アプリケーションへのアクセスは限定的です。"
  }
}
